import { Users, CalendarDays, Gauge, Headset, type LucideIcon } from 'lucide-react';

export interface Stat {
  number: string;
  label: string;
  icon: LucideIcon;
}

export const stats: Stat[] = [
  { number: '100+', label: 'Enterprise Clients', icon: Users },
  { number: '4', label: 'Years Experience', icon: CalendarDays },
  { number: '99.9%', label: 'Uptime Guarantee', icon: Gauge },
  { number: '24/7', label: 'Support Available', icon: Headset },
];
